import React from 'react';
import { Title } from 'react-admin';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ReleaseNotes = () => (
    <Box my={5}>
        <Title title="Release notes" />
        <Card>
            <CardHeader title="Release notes" />
            <CardContent>
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">02/12/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add some translations</li>
                            <li>Improve menu dividers when multiple permissions</li>
                            <li>Timesheet
                                <ul>
                                    <li>Reduce height on calendar view</li>
                                </ul>
                            </li>
                            <li>Dashboard
                                <ul>
                                    <li>Fix "My impact" tab when time entries are incomplete</li>
                                </ul>
                            </li>
                            <li>Dark theme
                                <ul>
                                    <li>Fix calendar icon color for date inputs</li>
                                    <li>Improve some buttons colors</li>
                                    <li>Fix status chip colors for invoices</li>
                                    <li>Lighten the primary color to improve readability on links</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">03/11/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add some translations</li>
                            <li>Timesheet
                                <ul>
                                    <li>Add calendar view</li>
                                </ul>
                            </li>
                            <li>Customers
                                <ul>
                                    <li>Add link to customer on id and name on list</li>
                                </ul>
                            </li>
                            <li>Leaves
                                <ul>
                                    <li>Displays half days in calendar</li>
                                    <li>Add required fields on forms</li>
                                </ul>
                            </li>
                            <li>Invoices
                                <ul>
                                    <li>Add invoices 1.0</li>
                                    <li>Add billing addresses</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">21/10/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add A.M.A, the Discord bot connected to Kernel</li>
                            <li>Users
                                <ul>
                                    <li>Add permissions</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">09/10/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Timesheet
                                <ul>
                                    <li>Adapt project and description inputs width on bulk create</li>
                                </ul>
                            </li>
                            <li>Leaves
                                <ul>
                                    <li>Improve the automatic leaves calculation with half-day</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">03/10/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Timesheet
                                <ul>
                                    <li>On help button, add link to timesheet guidelines</li>
                                    <li>Fix default sorting when searching projects</li>
                                </ul>
                            </li>
                            <li>Leaves
                                <ul>
                                    <li>Automatically excludes public holidays and weekends from leave calculation days</li>
                                    <li>Add public holidays to calendar</li>
                                    <li>Add automatic calculation of days on leave edit</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">29/09/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Settings
                                <ul>
                                    <li>Add feedback message when settings updated</li>
                                </ul>
                            </li>
                            <li>Dashboard
                                <ul>
                                    <li>Add chart for month on leaderboard</li>
                                </ul>
                            </li>
                            <li>Timesheet
                                <ul>
                                    <li>Adapt project input width and remove "invoiced" field on bulk create</li>
                                    <li>Add customer filter to list</li>
                                </ul>
                            </li>
                            <li>Projects
                                <ul>
                                    <li>Search for customer when searching projects</li>
                                </ul>
                            </li>
                            <li>Monthlies
                                <ul>
                                    <li>Fix default sorting</li>
                                </ul>
                            </li>
                            <li>Suggestions
                                <ul>
                                    <li>Fix default sorting</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">26/09/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Projects
                                <ul>
                                    <li>Add table with timesheet stats</li>
                                </ul>
                            </li>
                            <li>Dashboard
                                <ul>
                                    <li>On "Stats" tab (leaderboard), move month dropdown to improve UX</li>
                                </ul>
                            </li>
                            <li>Useful links
                                <ul>
                                    <li>Add link for Figma process</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">16/09/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add buttons for quick actions</li>
                            <li>Account
                                <ul>
                                    <li>Move theme settings</li>
                                    <li>Add settings for quick actions</li>
                                </ul>
                            </li>
                            <li>Useful links
                                <ul>
                                    <li>Add links for web process and project follow-up</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">22/08/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Timesheet
                                <ul>
                                    <li>Improve UX on bulk create
                                        <ul>
                                            <li>Add new line when pressing tab key</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">13/08/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>

                            <li>Dashboard
                                <ul>
                                    <li>Fix dark mode on impact tab</li>
                                    <li>Capitalize types on leaderboard tab</li>
                                </ul>
                            </li>
                            <li>Leaves
                                <ul>
                                    <li>Improve dark mode for status chip</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">04/08/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>

                            <li>Dashboard
                                <ul>
                                    <li>Add stats tab
                                        <ul>
                                            <li>Add leaderboard</li>
                                            <li>Add achievements tab</li>
                                            <li>Add impact tab</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>Projects
                                <ul>
                                    <li>Add "updated at" field</li>
                                </ul>
                            </li>
                            <li>Weeklies
                                <ul>
                                    <li>Add filters</li>
                                    <li>Add sort by date on grid view</li>
                                </ul>
                            </li>
                            <li>Leaves
                                <ul>
                                    <li>Add help button to leave create and edit</li>
                                </ul>
                            </li>
                            <li>Users
                                <ul>
                                    <li>Add user details page for non admin</li>
                                </ul>
                            </li>
                            <li>Useful Links
                                <ul>
                                    <li>Add Top/Flop</li>
                                    <li>Add "Rules" section</li>
                                </ul>
                            </li>
                            <li>Other
                                <ul>
                                    <li>Fix authentication to avoid too many calls when not logged in</li>
                                    <li>Fix achievements icons width</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">02/07/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Dashboard
                                <ul>
                                    <li>Fix current date when the page is not reloaded</li>
                                    <li>Improve timesheet warning card</li>
                                    <li>Add "quests" tab</li>
                                    <li>Display only unvoted suggestions</li>
                                </ul>
                            </li>
                            <li>Timesheet
                                <ul>
                                    <li>Bulk create
                                        <ul>
                                            <li>Fix current date when the page is not reloaded</li>
                                            <li>Improve help button</li>
                                            <li>Add total hours</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>Suggestions
                                <ul>
                                    <li>Add filter to display only unvoted suggestions</li>
                                </ul>
                            </li>
                            <li>Invoices (admin)
                                <ul>
                                    <li>Refacto components</li>
                                    <li>Add fake data temporarily</li>
                                    <li>Improve list
                                        <ul>
                                            <li>Add filters</li>
                                            <li>Improve chip style</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Achievements
                                <ul>
                                    <li>Add achievements</li>
                                    <li>Improve alignment</li>
                                </ul>
                            </li>
                            <li>Lists
                                <ul>
                                    <li>Remove row click that redirect to show</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">23/06/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add some French translations</li>
                            <li>
                                Timesheet
                                <ul>
                                    <li>List
                                        <ul>
                                            <li>Fix time entry list sync (sort, pagination, filters) when going in bulk create</li>
                                            <li>Add total hours</li>
                                            <li>Add quick update (description, type and hours)</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">16/06/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Update react-admin</li>
                            <li>Fix link in reset password mail</li>
                            <li>Dashboard
                                <ul>
                                    <li>Show current month by default on next leaves card</li>
                                    <li>Add warning cards</li>
                                </ul>
                            </li>
                            <li>
                                Timesheet
                                <ul>
                                    <li>Fix import button width</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">28/05/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Improve dark mode</li>
                            <li>
                                Projects
                                <ul>
                                    <li>Add stats tab with timesheet chart</li>
                                </ul>
                            </li>
                            <li>Weeklies
                                <ul>
                                    <li>Add edit button on weekly card to quickly update tasks</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">09/05/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>
                                Timesheet stats
                                <ul>
                                    <li>Improve tooltips</li>
                                    <li>Content is no longer cut (but can now overflow from the card)</li>
                                </ul>
                            </li>
                            <li>
                                Team status
                                <ul>
                                    <li>Add link to last weekly on occupancy rate and workload</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">30/04/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Fix position of color input picker (project, user)</li>
                            <li>
                                Leaves
                                <ul>
                                    <li>Create
                                        <ul>
                                            <li>Add helper text to "number of days" input</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Team status
                                <ul>
                                    <li>Adapt active projects colors</li>
                                    <li>Add tooltip with the date of the last weekly</li>
                                    <li>Disable occupancy rate and workload fields when the last weekly is 14 days old or more</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">31/03/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>
                                Suggestions
                                <ul>
                                    <li>Deactivation of comments when the suggestion is no longer new</li>
                                    <li>Can update comments</li>
                                    <li>List
                                        <ul>
                                            <li>Add comment count on list</li>
                                            <li>Limit title column width</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Weeklies & monthlies
                                <ul>
                                    <li>Weeklies and monthlies are now operational</li>
                                    <li>Add date input</li>
                                    <li>Add occupancy rate</li>
                                    <li>Adapt list</li>
                                </ul>
                            </li>
                            <li>
                                Team status
                                <ul>
                                    <li>Add user status list</li>
                                    <li>Add status input to account page</li>
                                </ul>
                            </li>
                            <li>
                                News
                                <ul>
                                    <li>Add news</li>
                                </ul>
                            </li>
                            <li>
                                Dashboard
                                <ul>
                                    <li>Add last news card</li>
                                    <li>Add new suggestions card</li>
                                    <li>Add calendar with next leaves</li>
                                    <li>Weekly and monthly cards are back</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">21/02/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>
                                Dashboard
                                <ul>
                                    <li>Fix responsive for last 7 days timesheet pie chart</li>
                                    <li>Hide weekly and monthly temporarily</li>
                                    <li>Improve pending leaves card for admin</li>
                                </ul>
                            </li>
                            <li>
                                Ideas box
                                <ul>
                                    <li>Add accept and refuse buttons for admin</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">17/02/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>
                                Time entries
                                <ul>
                                    <li>Fix last time entry list which showed the filters of the general list on the create page</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">29/01/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add ideas box</li>
                            <li>
                                Leaves
                                <ul>
                                    <li>Send mail when leave is accepted or refused</li>
                                </ul>
                            </li>
                            <li>
                                Time entries
                                <ul>
                                    <li>Export improvements</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">24/01/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>
                                Leaves
                                <ul>
                                    <li>Send mail when pending leaves</li>
                                    <li>Hide pending leaves when empty on dashboard (for admin)</li>
                                </ul>
                            </li>
                            <li>
                                Time entries
                                <ul>
                                    <li>Replace export button</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">23/01/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Fix account update when color empty</li>
                            <li>Hide next leaves card when empty on dashboard</li>
                            <li>Restrict custom pages to authenticated users</li>
                            <li>Add accordions to release notes to improve clarity</li>
                            <li>Fix reset password and forgot password inputs width</li>
                            <li>Update favicon</li>
                            <li>
                                Projects
                                <ul>
                                    <li>Fix project update, sometimes returned an error</li>
                                    <li>Display customer name instead of customer short name on project grid</li>
                                </ul>
                            </li>
                            <li>
                                Time entries
                                <ul>
                                    <li>Add tooltip with customer name to project field in time entry list</li>
                                    <li>Improve the way the customer is displayed on the project inputs</li>
                                    <li>Add project input with customer to timer page</li>
                                    <li>Add button to hide or show fields on time entry list</li>
                                    <li>Improve responsive on list</li>
                                    <li>Add help button to time entry edit</li>
                                </ul>
                            </li>
                            <li>
                                Customers
                                <ul>
                                    <li>Add customer details page</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">21/01/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Increase auth token validity to one week</li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography component="span">17/01/2025</Typography></AccordionSummary>
                    <AccordionDetails>
                        <ul>
                            <li>Add build date</li>
                            <li>Add "Release notes" page</li>
                            <li>
                                Time entries
                                <ul>
                                    <li>Add filter "for me" on list</li>
                                    <li>Reorder fields on bulk create</li>
                                    <li>Default date is current date on bulk create</li>
                                    <li>Add "created at" on update</li>
                                    <li>Take project alias instead of name for CSV export</li>
                                    <li>Show customer on some project inputs</li>
                                    <li>Fix title on bulk create</li>
                                </ul>
                            </li>
                            <li>
                                Project
                                <ul>
                                    <li>Add alias to search</li>
                                </ul>
                            </li>
                            <li>
                                Users
                                <ul>
                                    <li>Fix stats endpoint</li>
                                </ul>
                            </li>
                            <li>
                                Useful links
                                <ul>
                                    <li>Add followup</li>
                                    <li>Remove leaves and timesheet</li>
                                </ul>
                            </li>
                        </ul>
                    </AccordionDetails>
                </Accordion>
            </CardContent>
        </Card>
    </Box>
);

export default ReleaseNotes;